<template>
  <el-dialog
    title="选择分类"
    :visible.sync="visible"
    width="600px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose"
  >
    <el-table
      ref="consumablesRef"
      v-loading="loading"
      row-key="quarantineCode"
      :data="list"
      class="el-table__align"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        :reserve-selection="true"
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column
        label="分类名称"
        prop="quarantineName">
      </el-table-column>
      <el-table-column
        label="分类编码"
        width="130"
        prop="quarantineCode">
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'SelectModal',
  components: {},
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      selectList: [],
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.totalNum = 0
      this.config.pageNum = 1
      this.list = []
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getquarantines', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit() {
      this.callback && this.callback(this.selectList)
      this.toggleModal(false)
    },
    init(list) {
      console.log(list)
      this.toggleModal(true)
      this.$nextTick(() => {
        const ref = this.$refs.consumablesRef
        ref.clearSelection()
        list.forEach((i) => {
          ref.toggleRowSelection(i, true)
        })
        this.getlist()
      })
    }
  }
}
</script>
